export const CARBON_BLACK_LOAD_SYSTEM_PREF = "CARBON_BLACK_LOAD_SYSTEM_PREF";
export const CARBON_BLACK_SYSTEM_ENABLE = "CARBON_BLACK_SYSTEM_ENABLE";
export const CARBON_BLACK_SYSTEM_DISABLE = "CARBON_BLACK_SYSTEM_DISABLE";



// WEBPACK FOOTER //
// ./src/store/modules/system_pref/system-pref.type.js